import { render, staticRenderFns } from "./GestaoTerminal.vue?vue&type=template&id=1cc2a892"
import script from "./GestaoTerminal.vue?vue&type=script&lang=js"
export * from "./GestaoTerminal.vue?vue&type=script&lang=js"
import style0 from "./GestaoTerminal.vue?vue&type=style&index=0&id=1cc2a892&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports